import { render } from "./EditConfig.vue?vue&type=template&id=7b58a26f&scoped=true"
import script from "./EditConfig.vue?vue&type=script&lang=js"
export * from "./EditConfig.vue?vue&type=script&lang=js"

import "./EditConfig.vue?vue&type=style&index=0&id=7b58a26f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b58a26f"]])

export default __exports__